// src/services/tokenService.js
import axios from 'axios';

const refreshAccessToken = async () => {
    try {
        await axios.post(
            `${process.env.REACT_APP_API_BASE_URL || 'https://sharontelematics.org/api/'}auth/refresh`,
            {},
            { withCredentials: true }
        );

        return true;
    } catch (err) {
        return false;
    }
};

export default refreshAccessToken;